module.exports = __webpack_public_path__ + "icons/original/small/small-d6.83aaeda6a3e029931af97f484755879f.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-d6.png
// module id = hFVX
// module chunks = app